import { notification } from "antd";

export default (messages) => {
  messages
    ? messages.map((message) =>
        notification["success"]({
          message: message.title,
          description: message.description,
        })
      )
    : notification["success"]({
        message: "Great! Everything is done!",
      });
};
